module.exports = DDC.WsmCommonData;


//////////////////
// WEBPACK FOOTER
// external "DDC.WsmCommonData"
// module id = 44
// module chunks = 0